import * as React from 'react';
import { connect } from 'react-redux';
import { navigateTo } from '../../actions/navigationActions';
import { setGoToSpecialDebitSchedule } from '../../actions/profileActions';
import { PERSONAL_DETAILS } from '../../routes/routes';
import './SpecialDebit.css';

class SpecialDebitBanner extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {
            hasScheduled: false,
        };
        this.handleScheduleSpecialDebit = this.handleScheduleSpecialDebit.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
    }

    async handleScheduleSpecialDebit(destination) {
        await this.props.scheduleSpecialDebit();
        this.props.redirectTo(destination);
    }

    componentDidMount() {
        this.setState({
            hasScheduled: this.props.profile.specialDebitDate === "" ? false : true,
        })
    }

    render() {
        const { profile, firebase } = this.props;
        return (
            <>
                {!this.props.profile.hasScheduledSpecialDebit && !this.state.hasScheduled &&
                    <div className="row align-items-center noma cursor-pointer" id="SpecialDebitBanner" onClick={() => this.handleScheduleSpecialDebit(PERSONAL_DETAILS)}>
                        <div className="infoIcon align-self-center text-center"><img src="./images/White.svg" /></div>
                        <div className="col align-self-center nopa">Your recent payment of {this.props.profile.currencySymbol}{this.props.profile.specialDebitAmount} on {this.props.profile.personalPolicies[0].lastDebitOrderDate} failed. Tap <a id="BannerHere" onClick={() => this.handleScheduleSpecialDebit(PERSONAL_DETAILS)}>here</a> to schedule a special debit now.</div>
                        <div className="arrow align-self-center"><img src="./images/claims/Dropdown-arrow-right-white.png" /></div>
                    </div>
                }

                {(this.props.profile.hasScheduledSpecialDebit || this.state.hasScheduled) &&
                    <div className="row noma align-items-center cursor-pointer" id="SpecialDebitSuccessBanner" onClick={() => this.handleScheduleSpecialDebit(PERSONAL_DETAILS)}>
                        <div className="infoIcon align-self-center text-center"><img className="succesCheck" src="./images/ChilliDetails/MileageMonthly/icons-checkmark-checked.png" /></div>
                    <div className="col align-self-center ma-top-16px"><span><strong>Special debit scheduled &nbsp;&nbsp;|</strong> &nbsp;&nbsp;{this.props.profile.specialDebitDate}</span><br />
                            <p className="font-12"><strong><a onClick={() => this.handleScheduleSpecialDebit(PERSONAL_DETAILS)}>Tap here</a></strong> to reschedule this date</p></div>
                        <div className="arrow align-self-center"><img src="./images/PersonalDetails/icons-arrow-dropdown-right-grey.png"/></div>
                    </div>
                }
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        scheduleSpecialDebit: () => dispatch(setGoToSpecialDebitSchedule()),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(SpecialDebitBanner);